import React, { useState, useEffect } from 'react';
import WeightInput from './WeightInput';

import ScrollableContent from '../../../Scrolling/ScrollableContent';
const WeightingTable = ({ valuesIn, changeMade, key, readOnly }) => {
    const [valuesLocal, setValuesLocal] = useState([]);

    const setWeight = (obj) => {
        const unChanged = valuesLocal?.filter((s) => !s.changed);
        const changed = valuesLocal?.filter((s) => s.changed);

        let fixedValue = 0;
        fixedValue = changed.reduce((a, b) => {
            return a + parseFloat(b.percentage);
        }, 0);
        if (fixedValue > 100) {
            obj.percentage = obj.percentage - (fixedValue - 100);
            obj.weight = (obj.percentage / obj.basePercentage) * 100;
            fixedValue = 100;
        }

        let unFixedValue = 0;
        unFixedValue = unChanged.reduce((a, b) => {
            return a + parseFloat(b.basePercentage);
        }, 0);
        unChanged.map((a, b) => {
            a.percentage = ((100 - fixedValue) / unFixedValue) * a.basePercentage;
            a.weight = (a.percentage / a.basePercentage) * 100;
            return true;
        });
        setValuesLocal([...valuesLocal]);
    };
    useEffect(() => {}, [valuesLocal]);
    useEffect(() => {
        if (valuesIn) setValuesLocal(valuesIn);
    }, [valuesIn]);
    return (
        <div key={key} style={{ display: 'flex', position: 'relative' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div
                    style={{
                        display: 'flex',
                        marginLeft: 200,
                        fontSize: 12,
                        width: 500,
                        marginBottom: 10
                    }}
                >
                    <div
                        style={{
                            marginRight: 10,
                            position: 'relative',
                            left: -15
                        }}
                    >
                        {window.translate('Percentages')}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: 400
                        }}
                    >
                        <div>{window.translate('Downweight')}</div>
                        <div
                            style={{
                                textAlign: 'center',
                                position: 'relative',
                                left: 2
                            }}
                        >
                            {window.translate('Natural Delivery')}
                        </div>
                        <div>{window.translate('Upweight')}</div>
                    </div>
                </div>
                {valuesLocal?.length > 7 ? (
                    <ScrollableContent style={{ height: 308 }} completeHideFull={true} key={'scrollcont' + key}>
                        {valuesLocal?.map((a, b) => {
                            return (
                                <WeightInput
                                    id={'day' + b}
                                    index={b}
                                    key={'input' + b}
                                    name={a.name}
                                    sliderColor={
                                        readOnly ? (b % 2 ? '#CCCCCC' : '#919191') : b % 2 ? '#fdf1d6' : '#faa800'
                                    }
                                    obj={a}
                                    setWeight={setWeight}
                                    changeMade={changeMade}
                                    readOnly={readOnly}
                                ></WeightInput>
                            );
                        })}
                    </ScrollableContent>
                ) : (
                    valuesLocal?.map((a, b) => {
                        return (
                            <WeightInput
                                id={'day' + b}
                                index={b}
                                key={'input' + b}
                                name={a.name}
                                sliderColor={readOnly ? (b % 2 ? '#CCCCCC' : '#919191') : b % 2 ? '#fdf1d6' : '#faa800'}
                                obj={a}
                                setWeight={setWeight}
                                changeMade={changeMade}
                                readOnly={readOnly}
                            ></WeightInput>
                        );
                    })
                )}
            </div>
            <div
                style={{
                    width: 1,
                    borderRight: '1px solid #2c2c2c',
                    boxSizing: 'border-box',
                    marginLeft: 40,
                    marginRight: 40,
                    marginTop: 0,
                    height: valuesLocal.length * 45 + 17,
                    position: 'absolute',
                    left: 445,
                    top: 0,
                    pointerEvents: 'none'
                }}
            ></div>
        </div>
    );
};
export default WeightingTable;
